<!--
 * @Date: 2021-09-24 09:33:09
 * @LastEditors: natsu
 * @LastEditTime: 2021-09-24 09:39:58
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>phone-sdk</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/phone-sdk/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "release",
          linkList: [ur + "phone-sdk.umd.js", ur + "phone-sdk.css"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListPhoneSDK.vue